import { Component, OnInit, inject } from "@angular/core";
import { TasksClientProvider, TaskContactCreateCommand, ValidationResult, TaskDetailDto } from "src/app/web-api/web-api";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { FormControlBase } from "src/app/common-components/form-controls/form-control-base";
import { CstResponsivePopupComponentBase } from "src/app/common-components/resp-popup";

@Component({
    templateUrl: "./create.component.html",
    styleUrls: ["./create.component.scss"],
    standalone: false
})
export class PlanungApiTaskContactCreateComponent
    extends CstResponsivePopupComponentBase<string, TaskDetailDto>
    implements OnInit {
    private _client = inject(TasksClientProvider);
    private _fb = inject(FormBuilder);

    private _taskID = "";
    public form: FormGroup;

    ngOnInit(): void {
        this.form = this._fb.group({
            taskID: [this._taskID, Validators.required],
            email: ["", Validators.compose([Validators.required, Validators.email])],
            label: [""],
        });

        this._taskID = this.data;
        if (this.form) {
            this.form.patchValue({ taskID: this._taskID });
        }
    }

    public OnAccept() {
        if (!this.form.valid) {
            return;
        }
        const command = new TaskContactCreateCommand();
        command.init(this.form.value);
        this._client.contactCreate(command).subscribe(
            (result) => {
                this.close(result);
            },
            (error) => {
                if (error instanceof ValidationResult) {
                    FormControlBase.ApplyValidationResultToForm(this.form, error);
                    return;
                }
                console.log(error);
            }
        );
    }

    public OnCancel() {
        this.close();
    }
}
